import { INDIVIDUAL } from './_http';

const getPolicyDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/LifeInsurance/GetPolicyDetail`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getMyInsurances = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/api/Customer/${form.CustomerId}/summary`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getInsuranceDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}?ShowOnlyCustomerId=${form.customer}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getInsuranceDetailTwo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/api/Customer/${form.customer}/summary/${form.policy}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getPaymentList = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}/Collections`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getPaymentMethodsForAgito = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}/PolicyPaymentInfo`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getBankAccounts = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/BankAccounts?CustomerID=${form.customerId}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCustomerInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Customer/${form.CustomerId}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getCashflows = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Policies/${form.policy}/Cashflows`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getAgencyDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Agito/Agencies?agencyid=${form.id}&AgencyCode=${form.code}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getPolicyDetail, getMyInsurances, getInsuranceDetail, getInsuranceDetailTwo, getCustomerInfo, getPaymentList, getPaymentMethodsForAgito, getBankAccounts, getCashflows, getAgencyDetail }